import { createSelector } from 'reselect';
import { selectIsMobileMQ } from 'core/modules/MediaQueries/selectors';

import shuffle from 'lodash/shuffle';

export const selectPersonalizedTopOffers = state => state.personalizedTopOffers;
export const selectPersonalizedTopOffersConfig = createSelector(
  selectPersonalizedTopOffers,
  personalizedTopOffers => personalizedTopOffers.config,
);

export const selectPersonalizedTopOffersIsLoading = createSelector(
  selectPersonalizedTopOffers,
  personalizedTopOffers => personalizedTopOffers.isLoading,
);

export const selectPersonalizedTopOffersIsLoaded = createSelector(
  selectPersonalizedTopOffers,
  personalizedTopOffers => personalizedTopOffers.isLoaded,
);

export const selectPersonalizedTopOffersPlacements = createSelector(
  selectPersonalizedTopOffers,
  personalizedTopOffers => personalizedTopOffers.offers,
);

export const selectPersonalizedTopOffersPlacementsToDisplay = createSelector(
  [selectPersonalizedTopOffersPlacements, selectIsMobileMQ],
  (personalizedTopOffersPlacements, isMobileMQ) => {
    const numberToShow = isMobileMQ ? 5 : 12;
    return shuffle(personalizedTopOffersPlacements).slice(0, numberToShow);
  },
);
